import { isAnyPermitted, isPermitted } from "util/PermissionsMixin";
const EMPTY_PERMISSIONS = [];
const REQUIRED_INVESTIGATION_PERMISSIONS = ["investigations:create", "investigations:edit"].map(
  (perm) => perm
);
const REQUIRED_STREAM_PERMISSIONS = ["streams:read"];
export const ALL_EVENTS_STREAM_ID = "000000000000000000000002";
const normalizePermissions = (permissions) => permissions != null ? permissions : EMPTY_PERMISSIONS;
const hasInvestigationPermissions = (permissions) => isPermitted(normalizePermissions(permissions), REQUIRED_INVESTIGATION_PERMISSIONS);
const hasAllEventsStreamAccess = (permissions) => isAnyPermitted(normalizePermissions(permissions), [
  ...REQUIRED_STREAM_PERMISSIONS,
  `streams:read:${ALL_EVENTS_STREAM_ID}`
]);
const canUseAutoCreateInvestigation = (permissions) => hasInvestigationPermissions(permissions) && hasAllEventsStreamAccess(permissions);
export default canUseAutoCreateInvestigation;
